// extracted by mini-css-extract-plugin
export default {"provider-card":"_2ozG9a4iQr1fyRzP7kHcQB"};